// Dependencies
import React from 'react';

const DocExcel = ({ width, height, color, bgColor }) => {

  return (

    <svg
      width={width ? width : '30px'}
      height={height ? height : '30px'}
      viewBox="0 0 30 30"
    >
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icons-/-docs-/-excel">
          <g id="doc-excel">
            <circle id="Combined-Shape" fill={bgColor ? bgColor : "#80abba"} cx="15" cy="15" r="15"></circle>
            <path d="M20.25,8.25 L9.75,8.25 C8.925,8.25 8.25,8.925 8.25,9.75 L8.25,20.25 C8.25,21.075 8.925,21.75 9.75,21.75 L20.25,21.75 C21.075,21.75 21.75,21.075 21.75,20.25 L21.75,9.75 C21.75,8.925 21.075,8.25 20.25,8.25 L20.25,8.25 Z M18.15,18.75 L16.65,18.75 L15,15.9 L13.35,18.75 L11.85,18.75 L14.25,15 L11.85,11.25 L13.35,11.25 L15,14.1 L16.65,11.25 L18.15,11.25 L15.75,15 L18.15,18.75 L18.15,18.75 Z" id="Shape" fill={color ? color : '#FFFFFF'}></path>
          </g>
        </g>
      </g>
    </svg>

  );

}

export default DocExcel;
